<script setup lang="ts">
/**
 * 安全提示卡片。
 *
 * 三条硬规则（原实现的注释，逐条保留）：
 * 1. 只渲染服务端给的 `publicMessage`。`reason` / `categories` / `riskLevel`
 *    是给后台和审计看的，直接展示会把判定依据暴露给用户，也可能造成二次伤害。
 * 2. 热线必须是可点击的 `tel:` 链接——手机上这是唯一真正能拨出去的形式，
 *    纯文本号码要求用户手动抄写，在危机时刻是不可接受的摩擦。
 * 3. 用 `role="alert"` 而不是 `status`：读屏软件会打断当前朗读来播报它。
 */

import { CRISIS_HOTLINE } from '@spirit/contracts';

import { cn } from '../../lib/cn';

const props = defineProps<{ message: string; className?: string }>();
</script>

<template>
  <div
    role="alert"
    :class="cn('mt-2 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-900', props.className)"
  >
    <p class="flex items-center gap-1.5 font-medium">
      <span aria-hidden="true">⚠</span>安全提示
    </p>
    <p class="mt-1.5 leading-relaxed">{{ props.message }}</p>
    <p
      class="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 border-t border-red-200 pt-2 text-xs"
    >
      <a :href="`tel:${CRISIS_HOTLINE}`" class="font-medium underline underline-offset-2">
        拨打全国心理援助热线 {{ CRISIS_HOTLINE }}
      </a>
      <span class="text-red-700">如有立即危险，请拨打 110 / 120</span>
    </p>
  </div>
</template>
